import Auth from '../../redux/api/index';
import * as systemConstants from '../../constants/systemConstants';

export function login(params) {
  return (dispatch) => {
    dispatch({ type: systemConstants.LOGIN_REQUEST });
    const actionParams = { type: systemConstants.AUTH, dispatch };
    Auth.login(systemConstants.ELOGIN, params, actionParams);
  };
}

export function resetErrorMessage() {
  return { type: systemConstants.RESET_ERROR_MESSAGE };
}

export function resetRedirectForbidden() {
  return {
    type: systemConstants.RESET_REDIRECT_FORBIDDEN
  };
}
